import type { FaireProductEntity } from "../../entity_types/product";

export const p_e3bdrm2455: FaireProductEntity = {
  token: "p_e3bdrm2455",
  type: "product",
  name: "Matte Light Beige Ceramic Bud Vase",
  brandName: "Angle",
  imageUrl:
    "https://cdn.faire.com/fastly/d0a4b6f2a40c036a07b80479d1cced7825a94d887ef747408b6681e4e8e797c5.jpeg",
  priceDollars: 4.99,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/ac295d9dc4b04606d44fa8e8fd677af4ff0115fbb918a9ea02f7a72a0eb87439.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
